import { notificationChannelFns as thalamosNotificationChannelFns } from "@thalamos/common";
// Event names (and the channels they are sent to) can only contain characters which are alphanumeric, ‘-’ or ‘_’
export var NotificationEvents;
(function (NotificationEvents) {
    NotificationEvents["resourceReload"] = "resource-reload";
})(NotificationEvents || (NotificationEvents = {}));
// Channel names should only include lower and uppercase letters, numbers and the following punctuation _ - = @ , . ;
// Channel names may contain a maximum of 164 characters
export const notificationChannelFns = {
    user: {
        caseload: (userId) => `user.${userId}.caseload`,
        profile: (userId) => `user.${userId}.profile`,
        notifications: (userId) => `user.${userId}.notifications`,
    },
    org: {
        profile: (orgId) => `org.${orgId}.profile`,
    },
    team: {
        profile: (teamId) => `team.${teamId}.profile`,
        notifications: (teamId) => `team.${teamId}.notifications`,
    },
    work: {
        item: (itemId) => `work.${itemId}`,
        userItems: (userId) => `work.user.${userId}`,
        items: (teamOrOrganisationId) => `work.context.${teamOrOrganisationId}`,
        archive: (teamOrOrganisationId) => `work.archive.${teamOrOrganisationId}`,
    },
    formDraft: (formDraftId) => `formdraft.${formDraftId}`,
    form: (formId) => `form.${formId}`,
    formContext: (formContextId) => `form-context.${formContextId}`,
    interviews: (formContextId) => `interviews.${formContextId}`,
    patient: (patientId) => `patient.${patientId}`,
    patientTimeline: (patientId) => `patient.${patientId}.timeline`,
    mhaStatus: (patientId) => `patient.${patientId}.mha-status`,
    s132: (patientId) => `patient.${patientId}.s132`,
    ...thalamosNotificationChannelFns,
};
//# sourceMappingURL=thalamosNotification.js.map